import { useApi } from './use-api-call';


export const useSearchBoardApi = () => useApi<{ 
boards: BoardDTO[];
        allowEdit: boolean; 
    }>('/board/search-board');

export const useGetBoardApi = () => useApi<{ board: BoardDTO; allowEdit: boolean; }>('/board/get-board/{id}');

export const useSaveBoardApi = () => useApi<{ board: BoardDTO}>('/board/save-board');

export const useDeleteBoardApi = () => useApi('/board/delete-board/{id}');

export interface BoardDTO { 
id?:number;
title:string;
height:number;
width:number;
latitude:number;
longitude:number;
address:string;
createdAt?:Date;
createdBy?:string;
modifiedAt?:Date;
modifiedBy?:string;
}
